// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1isSn","head":"Table_head__3RYaX","col":"Table_col__2M9Wu"};